'use client'

import React from 'react'
import CategoriesSlider from './CategoriesSlider'
import { ourArticles } from '@/assets/data/our-articles'
import { useGetAllExternalLinksQuery } from '@/redux/services/externalLinksApi'

const OutArticles = () => {
  const { data } = useGetAllExternalLinksQuery()


  return (
    <div className='our-articles'>
      {data && <CategoriesSlider page='articles' list={data.filter((el)=>{return el?.enableToView === true})} />}
    </div>
  )
}

export default OutArticles
